import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { RealtimeHubService, HubEventRegistration } from '../shared/services/realtime-hub.service';
import { AgreementChangeTypeEnum } from '../models/enums/agreement-change-type-enum';

export interface AgreementsInvalidatedEvent {
  AgreementId: number | null;
  WorkerId: number | null;
  InstitutionId: number | null;
  ChangeType: AgreementChangeTypeEnum;
}

/**
 * SignalR service for worker agreements real-time invalidation.
 * Extends the generic RealtimeHubService with agreements-specific event.
 *
 * Note: The .NET backend sends anonymous objects which System.Text.Json
 * serializes using camelCase. We map them back to PascalCase to stay
 * consistent with the rest of the frontend DTO conventions.
 */
@Injectable({ providedIn: 'root' })
export class WorkerAgreementsSignalrService extends RealtimeHubService {
  private readonly invalidatedSubject = new Subject<any>();

  /** Emits each time the backend sends an AgreementsInvalidated event (mapped to PascalCase) */
  readonly invalidated$ = this.invalidatedSubject.asObservable().pipe(
    map((raw: any) => ({
      AgreementId: raw.agreementId ?? null,
      WorkerId: raw.workerId ?? null,
      InstitutionId: raw.institutionId ?? null,
      ChangeType: raw.changeType ?? 0,
    } as AgreementsInvalidatedEvent)),
  );

  protected readonly hubPath = 'workeragreementshub';

  protected readonly eventRegistrations: HubEventRegistration[] = [
    { eventName: 'AgreementsInvalidated', subject: this.invalidatedSubject },
  ];
}
